/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Filter } from '../../../model/Filter';
import { Command } from '../../../model/Command';
import { ListController } from '../../ListController';

class AlarmCodeListController extends ListController {
    /** @ngInject */
    constructor(waitSpinnerService, $q, $state, $stateParams, $log, notificationService,
        configuration, alarmCodeService, alarmTypeService, filterService, dialogService, $scope) {
        super(configuration, notificationService, waitSpinnerService, $state, $stateParams, $q, $log);
        this.alarmCodeService = alarmCodeService;
        this.alarmTypeService = alarmTypeService;
        this.filterService = filterService;
        this.dialogService = dialogService;
        this.$scope = $scope;
        // mdDataTable doesn't support ES6 syntax with $ctrl variable in templates. That's why we must attach the reload
        // callback to the scope with an arrow function so as it can be called by this component with the correct 'this'
        // binding.
        this.$scope.reload = () => this.reload();
        this.$log.debug('Controller \'AlarmCodeList\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.paging.sort = 'label';
        this.commands = [];
        this.initFilters();

        this.handleRestServiceCall(this.loadFilters(), () => {
            this.initCommands();
            this.reload();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        });
    }

    /**
     * Initializes the filters available at the top of the view.
     */
    initFilters() {
        this.alarmTypeFilter = Filter.equalFilterEmpty('type.id', 'model.alarmtype.alarmtype', 'SELECT', []);

        this.filters.push(
            Filter.emptyLikeFilter('label', 'model.alarmcode.label'),
            Filter.emptyLikeFilter('code', 'model.alarmcode.code'),
            this.alarmTypeFilter
        );
    }

    /**
     * Initializes the commands available in the view header.
     */
    initCommands() {
        this.commands.push(
            Command.stateCommand('ui.alarmcode.create', 'images/svg/add.svg', 'gmao.alarm.code.create'),
            Command.handlerCommand(undefined, 'images/svg/reset.svg', () => this.reload())
        );
    }

    /**
     * Loads data in filters.
     */
    loadFilters() {
        return this.getFilterAlarmTypes();
    }

    /**
     * Gets the list of alarm types.
     *
     * @return {Object[]} Promise providing an array of alarm types.
     */
    getFilterAlarmTypes() {
        return this.filterService.getFilterOptions(this.alarmTypeService, this.alarmTypeFilter, 'name');
    }

    /**
     * Reloads the list of alarm codes.
     *
     * @return {Promise} A promise providing the list of alarm codes.
     */
    reload() {
        return this.handleRestServiceCall(
            this.alarmCodeService.searchEntities({
                params: this.filterService.buildPagingParams(this.paging),
                data: this.filterService.buildFilters(this.filters)
            }),
            data => {
                this.model.data = data.content;
                this.model.totalElements = data.totalElements;
            }
        );
    }

    /**
     * Shows a confirmation dialog before deleting an alarm code. If the dialog is confirmed, the code is deleted.
     *
     * @param {integer} id ID of the alarm code.
     * @return {Promise} A promise containing the confirmation result.
     */
    showDeleteConfirmationDialog(id) {
        return this.dialogService.showConfirmationDialogWithMessage('ui.alarmcode.deleteconfirmation').then(
            confirmed => {
                if (confirmed) {
                    this.deleteAlarmCode(id);
                }
                return confirmed;
            }
        );
    }

    /**
     * Deletes immediately an alarm code without confirmation, and reloads the list of codes.
     *
     * @param {integer} id ID of the alarm code.
     */
    deleteAlarmCode(id) {
        return this.handleRestServiceCall(this.alarmCodeService.deleteEntity(id), () => {
            this.notificationService.pushMessage('ui.alarmcode.deleted',
                this.configuration.NOTIFIER_LEVEL_INFO);
            this.reload();
        });
    }
}

export const alarmCodeListComponent = {
    template: require('./alarmcode-list.html'),
    controller: AlarmCodeListController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmCodeList.js